// Gallery section — 6 slides from the legacy index page, 3-col grid on
// desktop / 2-col below 1024px; each figure opens the lightbox.
import { GALLERY_CAPTIONS, GALLERY_COUNT } from "./content";

interface GalleryProps {
  readonly onOpenImage: (index: number) => void;
}

export function Gallery({ onOpenImage }: GalleryProps) {
  return (
    <section className="wv-h2-section wv-h2-section--white" id="gallery">
      <div className="wv-h2-wrap">
        <h2>画廊</h2>
        <div className="wv-h2-section-rule"></div>
        <div className="wv-h2-gallery-grid">
          {Array.from({ length: GALLERY_COUNT }, (_, i) => i + 1).map((n) => (
            <figure className="wv-h2-figure" key={n}>
              <button onClick={() => onOpenImage(n - 1)} aria-label={`查看大图 ${n}`}>
                <img src={`/static/images/index/slides/thumb/${n}.jpg`} alt="随便MC" loading="lazy" />
              </button>
              <figcaption>{GALLERY_CAPTIONS[n - 1]}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
